import { ExpenseDealership } from "../class/expense-dealership";
import { ElementRef, Injectable } from "@angular/core";
import { responseUpdateExpensesProduct } from "app/components/class/http/res/response-update-expenses-product";
import { Tab } from "../class/tab";
import { GrandTotal } from "app/components/class/budget/grand-total";
import { Expense } from "app/components/class/expense/expense";
import { SingService } from "app/components/service/sing.service";

@Injectable()
export class Actions {
  tableIndex:number = 0;
  tableFieldId:string = "";
  startEditMode:boolean = false;
  onInitTabAction:boolean = false;
  onInitTabKey:any;

  actual_tab:Tab = null;
  target_tab:Tab = null;
  constructor( private elRef: ElementRef,private httpService: SingService){}
  public getAuthData() {
    return this.httpService.getAuthData();
}
  public onInitTab (event:any,rooftops:any, target:boolean) {
    event.preventDefault();
    event.stopPropagation();
    this.tableIndex++;
    if (this.tableIndex === rooftops.length) {
      this.tableIndex = 0;
    }
   
    if (event.target.getAttribute('subproduct'))
    {
      this.elRef.nativeElement.querySelector(`.editInput[subproduct="${this.tableFieldId}"][tabindex="${this.tableIndex}"]`).parentNode.querySelector((target) ? '.target' : '.actual').click();
  
    } else if (event.target.getAttribute('product'))
      {
        this.elRef.nativeElement.querySelector(`.editInput[product="${this.tableFieldId}"][tabindex="${this.tableIndex}"]`).parentNode.querySelector((target) ? '.target' : '.actual').click();
      } 
   
 
  }
  public formatMoney(n) {
    if (n % 1 === 0) {
      return ` ${n.toLocaleString('en')}`
    }
    var c = 2,
      d = ".",
      t = ",",
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0;
    return ` ${s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - parseFloat(i)).toFixed(c).slice(2) : "")}`;
  };
  public updateCategoryAfterChangeSumm(cat: any, expenseIndexes: any, data: responseUpdateExpensesProduct, index: number, rooftop) {
    let categories = cat;
    let indexProduct: number = data.category.products.findIndex(item => item.id === categories[expenseIndexes.category].products[expenseIndexes.product].id);
    
    let targetBudgetSub:number = 0;
    categories[expenseIndexes.category].expenses[index].setPlaned(data.category.price);
    categories[expenseIndexes.category].products[expenseIndexes.product].expenses[index].setPlaned(data.category.products[indexProduct].price);
    categories[expenseIndexes.category].products[expenseIndexes.product].subproducts.forEach(subproduct => {
       let indexSubProduct: number = data.category.products[indexProduct].subproducts.findIndex(item => item.id === subproduct.id);
      if (indexSubProduct !== (-1)) {
        subproduct.dealerShips[rooftop].targetBudget = data.category.products[indexProduct].subproducts[indexSubProduct].expenses[0].price;
        subproduct.expenses[index].setPlaned(data.category.products[indexProduct].subproducts[indexSubProduct].expenses[0].price);
        let dealerShips = subproduct.dealerShips;
        targetBudgetSub = 0;

        for (var prop in dealerShips) {
          targetBudgetSub += dealerShips[prop].targetBudget;
        }

        subproduct.targetBudget = this.formatMoney(targetBudgetSub);
      }
    });
   /* for (let u = 0; u < categories[expenseIndexes.category].products[expenseIndexes.product].subproducts.length; u++) {
      let indexSubProduct: number = data.category.products[indexProduct].subproducts.findIndex(item => item.id === categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[u].id);
      if (indexSubProduct !== (-1)) {
        categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[u].dealerShips[rooftop].targetBudget = data.category.products[indexProduct].subproducts[indexSubProduct].expenses[0].price;
        categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[u].expenses[index].expense = this.formatMoney(data.category.products[indexProduct].subproducts[indexSubProduct].expenses[0].price);
        let dealerShips = categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[u].dealerShips;
        targetBudgetSub = 0;

        for (var prop in dealerShips) {
          targetBudgetSub += dealerShips[prop].targetBudget;
        }

        categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[u].targetBudget = this.formatMoney(targetBudgetSub);
      }


    }*/

    let targetBudget:number = 0;

    let expenses = categories[expenseIndexes.category].products[expenseIndexes.product].expenses;
    expenses.forEach(expens => {
      targetBudget += expens.expenseNum;
    });
    
    let expensesCat = categories[expenseIndexes.category].expenses;
    let targetBudgetCat = 0;
    expensesCat.forEach(expens => {
      targetBudgetCat += expens.expenseNum;
    });
    
    categories[expenseIndexes.category].targetBudget = this.formatMoney(targetBudgetCat);
    categories[expenseIndexes.category].products[expenseIndexes.product].targetBudget = this.formatMoney(targetBudget);
    return categories;
  }
  public checkExistExpenses(c, rooftops) {
    for (let r in rooftops) {
      for (let p in c.products) {
        if (c.products[p].subproducts) {
          let countNoExist: number = 0;
          for (let s in c.products[p].subproducts) {
            if (c.products[p].subproducts[s].expenses[r].id === 0) {
              (<ExpenseDealership>c.products[p].subproducts[s].expenses[r]).setExist(false);
              countNoExist++;
            }
          }
          if (countNoExist === c.products[p].subproducts.length) {
            (<ExpenseDealership>c.products[p].expenses[r]).setExist(false);
          }
          if (countNoExist === c.products[p].subproducts.length && c.products[p].expenses[r].id !== 0) {
            (<ExpenseDealership>c.products[p].expenses[r]).setExist(true);
          }

        } else {
          if (c.products[p].expenses[r].id === 0) {
            (<ExpenseDealership>c.products[p].expenses[r]).setExist(false);
          }
        }
      }
    }
  }
  public updateExistExpenses(expenses, value: boolean) {
    for (let i in expenses) {
      expenses[i].notExist = value;
    }
  }
  public createExpense(global_rooftops, category, product, subproduct): any {
    let rooftops = [];
    for (let i in global_rooftops) {
      rooftops.push(new ExpenseDealership(category, product, subproduct, global_rooftops[i].id));
    }
    return rooftops;
  }
  public onUpdateCategoryDealerships(c, rooftops) {
    c.expenses = this.createExpense(rooftops, c, null, null);
    // for (let r in rooftops) {
    for (let p in c.products) {
      c.products[p].expenses = this.createExpense(rooftops, null, c.products[p], null);

      if (c.products[p].subproducts) {
        for (let s in c.products[p].subproducts) {
          c.products[p].subproducts[s].expenses = this.createExpense(rooftops, null, null, c.products[p].subproducts[s]);

        }
      }
    }
    // }
  }
  public updateGrandTotal (categories,rooftops):GrandTotal {
    let grandTotal:GrandTotal;
    let dealerShips:Object = {};
    let targetBudget:number = 0;
    categories.forEach(categori => {
      rooftops.forEach((rooftop,indexEx) => {
        
        if (dealerShips[rooftop.id] === undefined)  dealerShips[rooftop.id] = 0;
        dealerShips[rooftop.id] +=  categori.expenses[indexEx].expenseNum;
        targetBudget += categori.expenses[indexEx].expenseNum;
      })
    });
    grandTotal = new GrandTotal(dealerShips,targetBudget);
   
    return grandTotal;
  }
  public UpdateExpenseActual(expenses) {
    // e:ExpenseDealership
    for (let e in expenses) {
      expenses[e].convertTextExpense();
      expenses[e].convertTextActual();
    }
  }
  public convertType(d) {
    for (let c in d.categories) {
      this.UpdateExpenseActual(d.categories[c].expenses);
      for (let p in d.categories[c].products) {
        this.UpdateExpenseActual(d.categories[c].products[p].expenses);
        if (d.categories[c].products[p].subproducts) {
          for (let s in d.categories[c].products[p].subproducts) {
            this.UpdateExpenseActual(d.categories[c].products[p].subproducts[s].expenses);
          }
        }
      }
    }
  }
public updateExpense(categories,expenseIndexes,rooftops,expense:Expense) {
  let expProduct:number = 0;
  let actProduct:number = 0;
  let expCategory:number = 0;
  let actCategory:number = 0;
  if (expenseIndexes.campaign !== undefined) {
    categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[expenseIndexes.campaign].dealerShips[rooftops[expenseIndexes.rooftop].id].targetBudget = expense.targetBudget;
    categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[expenseIndexes.campaign].dealerShips[rooftops[expenseIndexes.rooftop].id].actualBudget = expense.actualBudget;
    categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[expenseIndexes.campaign].expenses[expenseIndexes.rooftop].setPlaned(expense.targetBudget);
    categories[expenseIndexes.category].products[expenseIndexes.product].subproducts[expenseIndexes.campaign].expenses[expenseIndexes.rooftop].setActual(expense.actualBudget);
    categories[expenseIndexes.category].products[expenseIndexes.product].subproducts.forEach(subproduct => {
      expProduct += subproduct.expenses[expenseIndexes.rooftop].expenseNum;
      actProduct += subproduct.expenses[expenseIndexes.rooftop].actualNum;
    });
    categories[expenseIndexes.category].products[expenseIndexes.product].expenses[expenseIndexes.rooftop].setPlaned(expProduct); 
    categories[expenseIndexes.category].products[expenseIndexes.product].expenses[expenseIndexes.rooftop].setActual(actProduct); 
   
  }else {
    categories[expenseIndexes.category].products[expenseIndexes.product].dealerShips[rooftops[expenseIndexes.rooftop].id].targetBudget = expense.targetBudget;
    categories[expenseIndexes.category].products[expenseIndexes.product].expenses[expenseIndexes.rooftop].setPlaned(expense.targetBudget);  
    categories[expenseIndexes.category].products[expenseIndexes.product].dealerShips[rooftops[expenseIndexes.rooftop].id].actualBudget = expense.actualBudget;
    categories[expenseIndexes.category].products[expenseIndexes.product].expenses[expenseIndexes.rooftop].setActual(expense.actualBudget);  
  }
  categories[expenseIndexes.category].products.forEach(product => {
    expCategory += product.expenses[expenseIndexes.rooftop].expenseNum;
    actCategory += product.expenses[expenseIndexes.rooftop].actualNum;
  });
  categories[expenseIndexes.category].expenses[expenseIndexes.rooftop].setPlaned(expCategory); 
  categories[expenseIndexes.category].expenses[expenseIndexes.rooftop].setActual(actCategory); 
  categories.forEach(categori => {
    let CategoryTargetBudget: number = 0;
    let CategoryActualBudget: number = 0;
    categori.products.forEach(product => {
      let ProductTargetBudget: number = 0;
      let ProductActualBudget: number = 0;
      if (product.subproducts) {
     
        product.subproducts.forEach(subproduct => {
          let SubProductTargetBudget: number = 0; 
          let SubProductActualBudget: number = 0; 
          subproduct.expenses.forEach(expense => {
            ProductTargetBudget += expense.expenseNum;
            ProductActualBudget += expense.actualNum;
            SubProductTargetBudget+= expense.expenseNum;
            SubProductActualBudget += expense.actualNum;
          });
          subproduct.targetBudget = this.formatMoney(SubProductTargetBudget);
          subproduct.actualBudget = this.formatMoney(SubProductActualBudget);
        });
       
      }  
        product.expenses.forEach(expense => {
          if (!product.subproducts) {
            ProductTargetBudget += expense.expenseNum;
            ProductActualBudget += expense.actualNum;
            
          }
          CategoryTargetBudget += expense.expenseNum;
          CategoryActualBudget += expense.actualNum;
        });
        product.targetBudget = this.formatMoney(ProductTargetBudget);
        product.actualBudget = this.formatMoney(ProductActualBudget);
    });
    categori.targetBudget = this.formatMoney(CategoryTargetBudget);
    categori.actualBudget = this.formatMoney(CategoryActualBudget);
  });
 
}
  public dealerTotals(c, rooftops) {
    this.onUpdateCategoryDealerships(c, rooftops);
    this.checkExistExpenses(c, rooftops);
    for (let r in rooftops) {
      for (let p in c.products) {
        if (c.products[p].subproducts) {
          for (let s in c.products[p].subproducts) {
            c.products[p].subproducts[s].expenses[r].expenseNum += c.products[p].subproducts[s].dealerShips[rooftops[r].id].targetBudget;
            c.products[p].subproducts[s].expenses[r].actualNum += c.products[p].subproducts[s].dealerShips[rooftops[r].id].actualBudget;
            c.products[p].subproducts[s].expenses[r].hasInvoices = (c.products[p].subproducts[s].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].subproducts[s].dealerShips[rooftops[r].id].hasInvoices : false;
            c.products[p].expenses[r].expenseNum += c.products[p].subproducts[s].dealerShips[rooftops[r].id].targetBudget;
            c.products[p].expenses[r].actualNum += c.products[p].subproducts[s].dealerShips[rooftops[r].id].actualBudget;
            c.products[p].expenses[r].hasInvoices = (c.products[p].subproducts[s].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].subproducts[s].dealerShips[rooftops[r].id].hasInvoices : false;
            c.expenses[r].expenseNum += c.products[p].subproducts[s].dealerShips[rooftops[r].id].targetBudget;
            c.expenses[r].actualNum += c.products[p].subproducts[s].dealerShips[rooftops[r].id].actualBudget;
            c.expenses[r].hasInvoices = (c.products[p].subproducts[s].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].subproducts[s].dealerShips[rooftops[r].id].hasInvoices : false;
          }
          if (c.products[p].dealerShips) {
            c.products[p].expenses[r].expenseNum += c.products[p].dealerShips[rooftops[r].id].targetBudget;
            c.products[p].expenses[r].actualNum += c.products[p].dealerShips[rooftops[r].id].actualBudget;
            c.products[p].expenses[r].hasInvoices = (c.products[p].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].dealerShips[rooftops[r].id].hasInvoices : false;
            c.expenses[r].expenseNum += c.products[p].dealerShips[rooftops[r].id].targetBudget;
            c.expenses[r].actualNum += c.products[p].dealerShips[rooftops[r].id].actualBudget;
            c.expenses[r].hasInvoices = (c.products[p].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].dealerShips[rooftops[r].id].hasInvoices : false;
          }
        } else {
          c.products[p].expenses[r].expenseNum += c.products[p].dealerShips[rooftops[r].id].targetBudget;
          c.products[p].expenses[r].actualNum += c.products[p].dealerShips[rooftops[r].id].actualBudget;
          c.products[p].expenses[r].hasInvoices = (c.products[p].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].dealerShips[rooftops[r].id].hasInvoices : false;
          c.expenses[r].expenseNum += c.products[p].dealerShips[rooftops[r].id].targetBudget;
          c.expenses[r].actualNum += c.products[p].dealerShips[rooftops[r].id].actualBudget;
          c.expenses[r].hasInvoices = (c.products[p].dealerShips[rooftops[r].id].hasInvoices !== undefined) ? c.products[p].dealerShips[rooftops[r].id].hasInvoices : false;
        }
      }
    }

  }
  public getFlightDate(settings: any, targetBudget: number) {
    let countDays = 32 - new Date(settings.year, settings.month - 1, 32).getDate();
    return [{
      start: `${settings.year}-${(settings.month < 10) ? "0" + settings.month : settings.month}-01`,
      end: `${settings.year}-${(settings.month < 10) ? "0" + settings.month : settings.month}-${(countDays < 10) ? "0" + countDays : countDays}`,
      targetBudget: targetBudget
    }];

  }
  public closedEditExpense() {
    
    let list_disabled = document.body.querySelectorAll('.tableCell-disabled');
  
    for (let l in list_disabled) {

      if (list_disabled[l] instanceof HTMLElement) {
        list_disabled[l].classList.remove('tableCell-disabled');
      }

    }
    
    let categori_body = document.body.querySelector(".dealership-selected");
    if (categori_body)
    {
      categori_body.classList.remove("dealership-selected");
    }
  
  }
  public onInitEditExpense(i: number, id: string, e) {
    
    let list_fixed = document.body.querySelector('#fixedHeader').querySelectorAll('.mainTableHeading');
    let list = document.body.querySelector('#tableHeading').querySelectorAll('.mainTableHeading');

    list[i].classList.add('dealership-selected');
    list_fixed[i].classList.add('dealership-selected');

    let list_items_budget = document.body.querySelectorAll('.item-budget');
    for (let u in list_items_budget) {
      if (list_items_budget[u] instanceof HTMLElement && list_items_budget[u].getAttribute("expenseId") !== id) {
        list_items_budget[u].classList.add("tableCell-disabled");
      }
    }
    let mainCell = document.body.querySelectorAll(".mainCell");

    for (let m in mainCell) {

      if (mainCell[m] instanceof HTMLElement) {
        mainCell[m].classList.add('tableCell-disabled');
      }

    }
    
    let categori_body = this.getParentElement(e.target, "categori-body");
   
   // categori_body.querySelector('.tableRow').querySelectorAll('.mainCell')[i].classList.remove('tableCell-disabled');
    
   // current_parent.classList.remove('tableCell-disabled');
  }
  private getParentElement(p, clas) {
    let parent = p;
    while (parent instanceof HTMLElement && !parent.classList.contains(clas)) {

      parent = parent.parentNode;

    }

    return parent;
  }

public onInitAddComapin() {
  this.elRef.nativeElement.querySelector('.add-subproduct').style.display = 'block';
  this.elRef.nativeElement.querySelector('.mask-confirm-add-subproduct').style.display = 'block';
}
public openWarning() {
  document.querySelector(".flightWarning").classList.remove('hid');
  document.querySelector(".darken").classList.remove('hid');
}
public setExistFiles(actualExpenseOpen:Expense,categories,value) {
  let indexCat:number = categories.findIndex(item => item.id === actualExpenseOpen.productCategoryId);
  if (indexCat > -1)
  {
  
   let indexProd:number = categories[indexCat].products.findIndex(item => item.id ===  actualExpenseOpen.productId);
  
   if (indexProd > -1)
   {
     if (categories[indexCat].products[indexProd].subproducts)
     {
       for (let u=0;u<categories[indexCat].products[indexProd].subproducts.length;u++)
     {
      let indexExp:number = categories[indexCat].products[indexProd].subproducts[u].expenses.findIndex(item => item.id === actualExpenseOpen.id);
      if (indexExp > -1)
      {
       for (let dealerShip in categories[indexCat].products[indexProd].subproducts[u].dealerShips) {
         if (categories[indexCat].products[indexProd].subproducts[u].dealerShips[dealerShip].expenseId === actualExpenseOpen.id)
         {
          categories[indexCat].products[indexProd].subproducts[u].dealerShips[dealerShip].hasInvoices = value;
           break;
         }
       
       }
      
       categories[indexCat].products[indexProd].subproducts[u].expenses.forEach((item) => {
         if (item.id === actualExpenseOpen.id)
         {
          item.hasInvoices = value;
         }
       })
      }
     }
      

     } else {
       let indexExp:number = categories[indexCat].products[indexProd].expenses.findIndex(item => item.id === actualExpenseOpen.id);
       if (indexExp > -1)
       {
        for (let dealerShip in categories[indexCat].products[indexProd].dealerShips) {
          if (categories[indexCat].products[indexProd].dealerShips[dealerShip].expenseId === actualExpenseOpen.id)
          {
            categories[indexCat].products[indexProd].dealerShips[dealerShip].hasInvoices = value;
            break;
          }
        
        }
       
        categories[indexCat].products[indexProd].expenses.forEach((item) => {
          if (item.id === actualExpenseOpen.id)
          {
           item.hasInvoices = value;
          }
        })
       }
      
     }
   
    
   }
  
  }
}
public openLargerEdit() {
  let zone = document.getElementById('dropzone');
  let imageDrop = document.getElementById('imageDrop');
  let close = document.getElementById('close');
  let uploaded = document.getElementById('uploadedFiles');
  close.classList.add('right');
  uploaded.classList.remove('hid');
  zone.classList.add('thinner');
  imageDrop.classList.add('lowerImage');
}
public closeLargerEdit() {
  let zone = document.getElementById('dropzone');
  let imageDrop = document.getElementById('imageDrop');
  let close = document.getElementById('close');
  let uploaded = document.getElementById('uploadedFiles');
  close.classList.remove('right');
  uploaded.classList.add('hid');
  zone.classList.remove('thinner');
  imageDrop.classList.remove('lowerImage');
}
public changeProgress(size, progress) {
  let sizeText = document.getElementById('uploadSize');
  let uploadDiv = document.getElementById('dropzone');
  let progressBar = document.getElementById('progressFill');
  uploadDiv.classList.add('shorter');
  progressBar.style.width = `${progress}px`;
  sizeText.innerHTML = size;
}
}


// WEBPACK FOOTER //
// ./src/app/components/budget/right-panel/services/actions.service.ts